import { trendingWords } from "@/mocks/gua";

const doubled = [...trendingWords, ...trendingWords];

export default function Trending() {
  return (
    <section className="border-b border-background-200 bg-background-50 py-10" aria-label="今日热议关键词">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-start gap-4 px-4 md:px-6">
        <div className="flex w-full items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-fire-fill text-base" aria-hidden="true" />
            </span>
            <h2 className="font-heading text-base font-black text-foreground-900 md:text-lg">今日热议 · 大家都在搜</h2>
          </div>
          <span className="hidden whitespace-nowrap text-xs text-foreground-600 sm:inline-flex">
            点选任意关键词快速开吃
          </span>
        </div>

        <div className="relative w-full overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-background-50 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-background-50 to-transparent" />
          <div className="animate-marquee flex w-max items-center gap-3">
            {doubled.map((word, idx) => (
              <a
                key={`${word}-${idx}`}
                href="#collection"
                className="whitespace-nowrap rounded-full border border-background-200 bg-white px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-accent-300 hover:bg-accent-50 hover:text-accent-800"
              >
                <i className="ri-hashtag mr-1 text-accent-600" aria-hidden="true" />
                {word}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}